var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10867_31792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2925 13.525C15.6745 12.1257 14.1772 10.1516 14.1772 5.22263C14.1772 2.36816 11.8549 0.0458984 9.00031 0.0458984C6.14537 0.0458984 3.82272 2.36816 3.82272 5.22263C3.82272 10.156 2.32595 12.1282 0.706532 13.5263C0.257549 13.9173 0 14.4805 0 15.0714C0 15.3967 0.263674 15.6604 0.588908 15.6604H6.17764C6.45027 16.9687 7.61206 17.9549 9 17.9549C10.3879 17.9549 11.5498 16.9688 11.8224 15.6604H17.4111C17.7363 15.6604 18 15.3967 18 15.0714C18 14.4757 17.7418 13.9117 17.2925 13.525ZM9 16.7771C8.26661 16.7771 7.63994 16.3115 7.39966 15.6604H10.6003C10.3601 16.3115 9.73339 16.7771 9 16.7771ZM1.40977 14.4825C1.4312 14.4593 1.45405 14.4372 1.47816 14.4162C3.94709 12.2847 5.00045 9.53516 5.00045 5.22263C5.00045 3.01761 6.79482 1.22371 9.00024 1.22371C11.2053 1.22371 12.9993 3.01761 12.9993 5.22263C12.9993 9.53124 14.0528 12.2807 16.523 14.4167C16.5471 14.4375 16.57 14.4595 16.5915 14.4825H1.40977Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10867_31792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.ae30d7535ac9d4b53c1336de59c7b256.svg";
export { ForwardRef as ReactComponent };